export * from "./delete-confirm-modal.component";
